// extracted by mini-css-extract-plugin
module.exports = {"notification":"NotificationsDeactivation_notification__4c3Cx","error":"NotificationsDeactivation_error__2CM_B"};